// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__3iecq","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2i9tC"};